module.exports = __webpack_public_path__ + "img/SeedStage.3c2d242f.png";